import React from 'react';
import { Cpu, Zap, Crosshair } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function SolutionSection() {
  return <section className="py-24 relative overflow-hidden bg-[#050a14]" data-id="element-248">
      {/* Tech background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00d9ff] to-transparent opacity-50" data-id="element-249" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00d9ff] to-transparent opacity-50" data-id="element-250" />
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-96 h-96 bg-[#00d9ff]/10 blur-[100px] rounded-full pointer-events-none" data-id="element-251" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-252">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-253">
          <div data-id="element-254">
            <FadeIn data-id="element-255">
              <div className="flex items-center gap-2 text-[#00d9ff] font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-256">
                <Cpu className="w-5 h-5" data-id="element-257" />
                <span data-id="element-258">El Mecanismo Único</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-259">
                Presentamos el <br data-id="element-260" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d9ff] to-white" data-id="element-261">
                  Método P.V.R.
                </span>
              </h2>
              <p className="text-xl text-gray-300 mb-8 font-medium" data-id="element-262">
                (Patrón de Valor Repentino)
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-263">
              <div className="space-y-6 text-gray-400" data-id="element-264">
                <p data-id="element-265">
                  A diferencia de los consejos de seducción tradicionales, este
                  protocolo utiliza la lógica de la{' '}
                  <strong className="text-white" data-id="element-266">
                    Inteligencia Artificial
                  </strong>{' '}
                  para eliminar el error emocional humano.
                </p>
                <p data-id="element-267">
                  Es un sistema de comunicación quirúrgica diseñado para romper
                  la expectativa de tu ex. Al cambiar drásticamente tu patrón de
                  respuesta (de rogar a una neutralidad estratégica), obligas a
                  su cerebro a re-evaluar tu importancia.
                </p>
              </div>
            </FadeIn>
          </div>

          <div className="relative" data-id="element-268">
            <FadeIn delay={0.3} direction="left" data-id="element-269">
              <div className="bg-glass border border-[#00d9ff]/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-270">
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#00d9ff]/20 blur-3xl" data-id="element-271" />

                <div className="relative z-10 space-y-8" data-id="element-272">
                  <div className="flex gap-4" data-id="element-273">
                    <div className="w-12 h-12 rounded-full bg-[#00d9ff]/10 flex items-center justify-center flex-shrink-0 border border-[#00d9ff]/30" data-id="element-274">
                      <Crosshair className="w-6 h-6 text-[#00d9ff]" data-id="element-275" />
                    </div>
                    <div data-id="element-276">
                      <h4 className="text-white font-bold text-lg mb-1" data-id="element-277">
                        Precisión Quirúrgica
                      </h4>
                      <p className="text-sm text-gray-400" data-id="element-278">
                        Mensajes diseñados para evadir defensas psicológicas.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4" data-id="element-279">
                    <div className="w-12 h-12 rounded-full bg-[#00d9ff]/10 flex items-center justify-center flex-shrink-0 border border-[#00d9ff]/30" data-id="element-280">
                      <Zap className="w-6 h-6 text-[#00d9ff]" data-id="element-281" />
                    </div>
                    <div data-id="element-282">
                      <h4 className="text-white font-bold text-lg mb-1" data-id="element-283">
                        Vacío de Poder
                      </h4>
                      <p className="text-sm text-gray-400" data-id="element-284">
                        Genera una intriga que solo pueden llenar escribiéndote.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Decorative code snippet */}
                <div className="mt-8 pt-6 border-t border-white/10 font-mono text-xs text-[#00d9ff]/70" data-id="element-285">
                  <p data-id="element-286">{`> INITIALIZING P.V.R. PROTOCOL...`}</p>
                  <p data-id="element-287">{`> EMOTIONAL_STATE = NEUTRAL`}</p>
                  <p data-id="element-288">{`> VALUE_PATTERN = DISRUPTED`}</p>
                  <p className="text-white mt-2" data-id="element-289">{`> STATUS: READY TO DEPLOY`}</p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}